<template>
  <div class="px-2 py-1.5 truncate" v-if="header.type == 'select'">
    {{ displayValue && displayValue != "" ? displayValue : "" }}
  </div>
  <input-checkbox
    v-else-if="header.type == 'checkbox'"
    class="w-8 mx-2 justify-self-center"
    :id="`table-checkbox-${item.id}`"
    :modelValue="displayValue"
    :defaultColor="'grey'"
    :activeColor="'primary'"
    @change="handleCheckboxChange"
  />
  <div class="px-2 py-1.5 truncate" :title="displayValue" v-else>
    {{ displayValue }}
  </div>
</template>

<script>
import { computed, defineComponent } from "vue";
import { getData } from "../../common/dataHelper";
import InputCheckbox from "../input/InputCheckbox.vue";

export default defineComponent({
  components: { InputCheckbox },
  name: "TableItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
    header: {
      type: Object,
      required: true,
    },
  },
  emits: ["change"],
  setup(props, context) {
    function handleCheckboxChange(value) {
      context.emit("change", value);
    }

    const displayValue = computed(() => {
      if (!props.header.type || props.header.type === "input") {
        return getData(props.item, props.header.dbValue) ?? "-";
      }
      if (props.header.type === "checkbox") {
        return getData(props.item, props.header.dbValue);
      }
      if (props.header.type === "select") {
        return getData(props.item, props.header.dbValue);
      }
      return "unknown Type";
    });
    return { handleCheckboxChange, displayValue };
  },
});
</script>
